<template>
  <div class="home" id="container">
    <TopPanel @onLanguageSelected="setLanguage"/>
    <div class="col-12" style="margin-top: 5em; color: #f8f8f8">
      <h3 style="color: #faa633; padding-top: 1em; text-align: left">Routa - Tietosuoja</h3>
      Sivun dokumentit sekä ohjeet koskevat Routa-järjestelmän käyttöä ml. seuraavat mobiilisovellukset:
      <ul>
        <li>Routa Ajoneuvo</li>
        <li>Routa Paving</li>
        <li>Routa Työaika</li>
        <li>Routa Forest</li>
        <li>Routa Liikennemerkit</li>
      </ul>
    </div>
    <div class="col-12">
      <b-table :items="gdprDocuments" :fields="manualFields" striped hover thead-class="hidden_header" style="background: #ffffff; cursor: pointer" @row-clicked="openFileFromAssets"/>
    </div>
    <div class="col-12" style="color: #f8f8f8">
      <h2 style="color: #faa633; padding-top: 1em; text-align: left">Omat tietosi</h2>
      Routa-järjestelmä kerää tietoja työn suorituksesta ja suoritustietojen säilyttämiseen liittyy oikeudellinen peruste esim. korvausvaatimustapausten käsittelyssä.
      Tästä johtuen työn suoritustietoja ei voida poistaa. Tietojen poistopyynnöt käsitellään yhdessä työsuoritteisiin liittyvien organisaatioiden kanssa. <br><br>
      Käyttäjätiliin liitetyt yhteystiedot sekä käyttöoikeudet voidaan poistaa.<br><br>
      Voit pyytää käyttäjätilisi sekä omien tietojesi poistamista järjestelmästä ottamalla asiakaspalveluumme yhteyttä sähköpostitse <strong>info@routasystems.com</strong>.
      <h3 style="color: #faa633; padding-top: 1em; text-align: left">Tietojen kerääminen</h3>
      Lue tarkemmin tietojen keräämisestä yo. dokumenteista.<br><br>
      Sovelluksen käyttäjärekisterin käyttötarkoituksena on kerätä tietoa liikkuvasta työstä liiketoimintaan liittyvää laskutusta, lakisääteisten vaatimusten toteuttamista, palkanmaksua sekä maastotyön turvallisuuden parantamista varten.<br>
      Käsittely on tarpeen sopimuksen täytäntöön panemiseksi, jossa rekisteröity on osapuolena, tai sopimuksen tekemistä edeltävien toimenpiteiden toteuttamiseksi rekisteröidyn pyynnöstä.<br>
      Käsittely on tarpeen rekisterinpitäjän lakisääteisen velvoitteen noudattamiseksi.<br>
      Käsittely on tarpeen rekisteröidyn tai toisen luonnollisen henkilön elintärkeiden etujen suojaamiseksi.<br><br>
      Rekisterin henkilötietoja kerätään suoraan rekisteröidyltä itseltään tai rekisteröidyn työn- tai toimeksiantajalta. Järjestelmän sovellukset keräävät ajoneuvojen reittitietoja automaattisesti ja käyttötapauksen mukaan myös työntekijän sijaintitietoa kerätään sovelluksissa automaattisesti. Sijaintitietoa kerätään ainoastaan silloin, kun henkilö on sovellukseen kirjautunut ja/ tai merkinnyt itsensä töihin.
    </div>
    <hr/>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import TopPanel from "@/components/TopPanel";
import Footer from "@/components/Footer";

export default {
  name: 'terms',
  components: {
    Footer,
    TopPanel
  },
  data () {
    return {
      locale: this.getLanguage(),
      manualFields: [
        {key: 'filename', label: this.$t('privacy.document')},
        {key: 'description', label: this.$t('privacy.description')}
      ],
      gdprDocuments: [
        {filename: 'Routa-Tietosuoja_UKK_20210218', description: this.$t('privacy.faq'), link: 'https://routasystems.com/faq.pdf'},
        {filename: 'Routa-Tietosuojaseloste_20210110', description: this.$t('privacy.policy'), link: 'https://routasystems.com/privacy.pdf'},
      ]
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  },
  methods: {
    setLanguage: function (lang) {
      this.locale = lang
    },
    getLanguage: function () {
      let lang = navigator.language.split('-')[0]
      switch (lang) {
        case 'en':
          return 'en'
        case 'fi':
          return 'fi'
        case 'fr':
          return 'fr'
      }
      return 'en'
    },
    openFileFromAssets: function (record) {
      window.open(record.link,'_blank');
    }
  }
}
</script>
